/** Legacy CCW catalog product id when ccwVehicleTypePricing is unset on product. */
export const CCW_SPARKLE_PRODUCT_ID = "68be9ff4c97473acf124ce94";

/** Legacy CCW catalog fallback when ccwVehicleTypePricing is unset on product. */
export const CCW_SPARKLE_VEHICLE_MONTHLY = {
  sedan: 49,
  wagon: 59,
  "4wd": 69,
};

const BILLING_DIVISOR_MONTHLY = 12;

function parsePositiveNumber(value) {
  if (value == null || value === "") return null;
  const n = parseFloat(value);
  return Number.isFinite(n) && n > 0 ? n : null;
}

export function productHasCcwVariantPricing(productInfo) {
  const tiers = productInfo?.ccwVehicleTypePricing;
  if (!tiers || typeof tiers !== "object") return false;
  return ["sedan", "wagon", "4wd"].some(
    (key) => parsePositiveNumber(tiers[key]) != null,
  );
}

/** CCW customer checkout monthly price (not merchant billing). */
export function resolveCcwMonthlyPrice(productId, vehicleType, productInfo) {
  if (!vehicleType) return null;

  const fromProduct = parsePositiveNumber(
    productInfo?.ccwVehicleTypePricing?.[vehicleType],
  );
  if (fromProduct != null) return fromProduct;

  if (isSparkleVariantProduct(productId) && CCW_SPARKLE_VEHICLE_MONTHLY[vehicleType] != null) {
    return CCW_SPARKLE_VEHICLE_MONTHLY[vehicleType];
  }

  return null;
}

export function isSparkleVariantProduct(productId) {
  if (!productId) return false;
  return String(productId) === CCW_SPARKLE_PRODUCT_ID;
}

/** Vehicle type required when product uses variant pricing (checkout and/or merchant redemption). */
export function productSupportsVehicleTypeSelection(productId, productInfo) {
  return (
    productHasCcwVariantPricing(productInfo) ||
    isSparkleVariantProduct(productId) ||
    productInfo?.supportsVehicleVariantPricing === true
  );
}

/**
 * Annual RRP for checkout. Without CCW site context, always uses link RRP (no vehicle tiers).
 */
export function resolveCheckoutRrp({
  productId,
  vehicleType,
  urlRrp,
  productInfo,
  hasCcwSiteContext = false,
}) {
  const parsed = parseFloat(urlRrp);
  const linkRrp = Number.isFinite(parsed) && parsed >= 0 ? parsed : null;

  if (!hasCcwSiteContext) {
    return linkRrp;
  }

  const vt = vehicleType || null;
  if (vt) {
    const ccwMonthly = resolveCcwMonthlyPrice(productId, vt, productInfo);
    if (ccwMonthly != null) return ccwMonthly * BILLING_DIVISOR_MONTHLY;
  }

  return linkRrp;
}

export function formatMonthlyPrice(audPerMonth) {
  if (audPerMonth == null) return null;
  return `$${audPerMonth.toFixed(2)}/month`;
}
